import { render, staticRenderFns } from "./RequestWorksSection.vue?vue&type=template&id=7c48395e&"
import script from "./RequestWorksSection.vue?vue&type=script&lang=js&"
export * from "./RequestWorksSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QSeparator,QItem} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QIcon,QSeparator,QItem}, component.options.components || {})
